import { render } from "./VdbFooter.vue?vue&type=template&id=1ec5b918&scoped=true"
import script from "./VdbFooter.vue?vue&type=script&lang=js"
export * from "./VdbFooter.vue?vue&type=script&lang=js"

import "./VdbFooter.vue?vue&type=style&index=0&id=1ec5b918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec5b918"]])

export default __exports__